import React from 'react';
import classes from './style.module.scss';
import Logotype from '../../media/logo.svg';

const Logo = () => {
    return (
        <a className={classes.logo} href="/">
            <img className={classes.logo} src={Logotype} alt="logo" />
        </a>
    );
};

export default Logo;
